module.exports = __webpack_public_path__ + "static/img/banner.110efcc4.png";